import PropTypes from "prop-types"

import { cn } from "styles/utils"

import Button from "./button"
import Modal from "./modal"

const Confirmation = ({
  cancelDisabled,
  cancelText,
  confirmDisabled,
  confirmLoading,
  confirmText,
  description,
  modalType,
  onCancel,
  onConfirm,
  primary,
  show,
  title,
  ...props
}) => {
  return (
    <Modal
      height="fit-content"
      label={title}
      modalType={modalType}
      onClose={onCancel}
      onOutsideClick={onCancel}
      show={show}
      width="400px"
      {...props}
    >
      <div className="text-18 leading-24 mb-24 text-center font-medium">
        {description}
      </div>
      <div className="tablet:gap-10 flex flex-wrap gap-16">
        {cancelText && (
          <ActionBtn
            data-cy="modal-confirmation-cancel-btn"
            disabled={cancelDisabled}
            onClick={onCancel}
            primary={primary === "cancel"}
          >
            {cancelText}
          </ActionBtn>
        )}
        {confirmText && (
          <ActionBtn
            data-cy="modal-confirmation-confirm-btn"
            disabled={confirmDisabled}
            loading={confirmLoading}
            onClick={onConfirm}
            primary={primary === "confirm"}
          >
            {confirmText}
          </ActionBtn>
        )}
      </div>
    </Modal>
  )
}

Confirmation.propTypes = {
  cancelDisabled: PropTypes.bool,
  cancelText: PropTypes.string,
  confirmDisabled: PropTypes.bool,
  confirmLoading: PropTypes.bool,
  confirmText: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  modalType: PropTypes.oneOf(["popup", "slideup", "slideright"]),
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  primary: PropTypes.oneOf(["confirm", "cancel"]),
  show: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

Confirmation.defaultProps = {
  modalType: "slideup",
  primary: "confirm",
}

const ActionBtn = ({ primary, ...props }) => (
  <div className="flex-1">
    <Button
      className={cn(
        "text-18 tracking-half h-48 w-full whitespace-nowrap rounded-md font-medium leading-none",
        primary ? "bg-cta text-white" : "text-primary border-primary border"
      )}
      {...props}
    />
  </div>
)

ActionBtn.propTypes = {
  primary: PropTypes.bool,
}

export default Confirmation
